import React, { lazy, Suspense } from "react";

const LazyDashboard = lazy(() => import("./courses"));

const Cousrse = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => {
  return (
    <Suspense fallback={<div></div>}>
      <LazyDashboard  />
    </Suspense>
  );
};

export default Cousrse;
